import { SagaIterator } from "redux-saga";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    BulkCustomerCicReportingDownloadSaga,
    BulkCustomerCicReportingFileCheckerRemarkSaga,
    BulkCustomerCicReportingFileMakerRemarkSaga,
    bulkCustomerCicReportingType,
    BulkCustomerCicReportingVersionSaga,
    fetchBulkCustomerCicReportingDetailSaga,
    fetchBulkCustomerCicReportingSaga,
    uploadBulkCustomerCicReportingFileSaga
} from "./types";
import {
    approveBulkCustomerCicReportingFileApi,
    BulkCustomerCicReportingPublishApi,
    deleteBulkCustomerCicReportingFileApi,
    downloadBulkCustomerCicReportingFileApi,
    fetchBulkCustomerCicReportingApi,
    fetchBulkCustomerCicReportingDetailApi,
    fetchBulkCustomerCicReportingVersionApi,
    fetchBulkFileSpecificCustomerCicReportingApi,
    rejectBulkCustomerCicReportingFileApi,
    uploadBulkCustomerCicReportingFileApi
} from "./api";

function* uploadBulkCustomerCicReporting({ payload }: uploadBulkCustomerCicReportingFileSaga): SagaIterator {
    try {
        const response = yield call(uploadBulkCustomerCicReportingFileApi, payload);

        yield put({
            type: bulkCustomerCicReportingType.UPLOAD_BULK_CUSTOMER_CIC_REPORTING_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkCustomerCicReportingType.UPLOAD_BULK_CUSTOMER_CIC_REPORTING_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchBulkCustomerCicReporting({ payload }: fetchBulkCustomerCicReportingSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkCustomerCicReportingApi, payload);

        yield put({
            type: bulkCustomerCicReportingType.FETCH_BULK_CUSTOMER_CIC_REPORTING_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkCustomerCicReportingType.FETCH_BULK_CUSTOMER_CIC_REPORTING_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchBulkCustomerCicReportingDetail({ payload }: fetchBulkCustomerCicReportingDetailSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkCustomerCicReportingDetailApi, payload);

        yield put({
            type: bulkCustomerCicReportingType.FETCH_BULK_CUSTOMER_CIC_REPORTING_DETAIL_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkCustomerCicReportingType.FETCH_BULK_CUSTOMER_CIC_REPORTING_DETAIL_ERROR,
            payload: { error: error }
        });
    }
}

function* BulkCustomerCicReportingVersion({ payload }: BulkCustomerCicReportingVersionSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkCustomerCicReportingVersionApi, payload);

        yield put({
            type: bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_VERSION_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_VERSION_ERROR,
            payload: { error: error }
        });
    }
}

function* BulkCustomerCicReportingPublish({ payload }: BulkCustomerCicReportingFileMakerRemarkSaga): SagaIterator {
    try {
        const response = yield call(BulkCustomerCicReportingPublishApi, payload);
        yield put({
            type: bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_PUBLISH_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_PUBLISH_ERROR,
            payload: { error: error }
        });
    }
}

function* downloadBulkCustomerCicReportingFile({ payload }: BulkCustomerCicReportingDownloadSaga): SagaIterator {
    try {
        const response = yield call(downloadBulkCustomerCicReportingFileApi, payload);
        const file = payload.downloadURL.split("/");
        const responseData = {
            fileBlob: response.data,
            fileName: file[file.length - 1]
        };
        yield put({
            type: bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_FILE_DOWNLOAD_SUCCESS,
            payload: { data: responseData }
        });
    } catch (error: any) {
        yield put({
            type: bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_FILE_DOWNLOAD_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchBulkFileSpecificCustomerCicReporting({ payload }: BulkCustomerCicReportingVersionSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkFileSpecificCustomerCicReportingApi, payload);

        yield put({
            type: bulkCustomerCicReportingType.FETCH_BULK_FILE_SPECIFIC_CUSTOMER_CIC_REPORTING_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkCustomerCicReportingType.FETCH_BULK_FILE_SPECIFIC_CUSTOMER_CIC_REPORTING_ERROR,
            payload: { error: error }
        });
    }
}

function* approveBulkCustomerCicReportingFile({ payload }: BulkCustomerCicReportingFileCheckerRemarkSaga): SagaIterator {
    try {
        const response = yield call(approveBulkCustomerCicReportingFileApi, payload);
        yield put({
            type: bulkCustomerCicReportingType.APPROVE_BULK_CUSTOMER_CIC_REPORTING_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkCustomerCicReportingType.APPROVE_BULK_CUSTOMER_CIC_REPORTING_FILE_ERROR,
            payload: { error: error }
        });
    }
}

function* rejectBulkCustomerCicReportingFile({ payload }: BulkCustomerCicReportingFileCheckerRemarkSaga): SagaIterator {
    try {
        const response = yield call(rejectBulkCustomerCicReportingFileApi, payload);

        yield put({
            type: bulkCustomerCicReportingType.REJECT_BULK_CUSTOMER_CIC_REPORTING_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkCustomerCicReportingType.REJECT_BULK_CUSTOMER_CIC_REPORTING_FILE_ERROR,
            payload: { error: error }
        });
    }
}


function* deleteBulkCustomerCicReportingFile({ payload }: fetchBulkCustomerCicReportingDetailSaga): SagaIterator {
    try {
        const response = yield call(deleteBulkCustomerCicReportingFileApi, payload);
        yield put({
            type: bulkCustomerCicReportingType.DELETE_BULK_CUSTOMER_CIC_REPORTING_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkCustomerCicReportingType.DELETE_BULK_CUSTOMER_CIC_REPORTING_FILE_ERROR,
            payload: { error: error }
        });
    }
}

export function* watchUploadBulkCustomerCicReporting() {
    yield takeEvery(bulkCustomerCicReportingType.UPLOAD_BULK_CUSTOMER_CIC_REPORTING, uploadBulkCustomerCicReporting);
}

export function* watchFetchBulkCustomerCicReporting() {
    yield takeEvery(bulkCustomerCicReportingType.FETCH_BULK_CUSTOMER_CIC_REPORTING, fetchBulkCustomerCicReporting);
}

export function* watchFetchBulkCustomerCicReportingDetail() {
    yield takeEvery(bulkCustomerCicReportingType.FETCH_BULK_CUSTOMER_CIC_REPORTING_DETAIL, fetchBulkCustomerCicReportingDetail);
}

export function* watchBulkCustomerCicReportingVersion() {
    yield takeEvery(bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_VERSION, BulkCustomerCicReportingVersion);
}

export function* watchBulkCustomerCicReportingPublish() {
    yield takeEvery(bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_PUBLISH, BulkCustomerCicReportingPublish);
}

export function* watchDownloadBulkCustomerCicReporting() {
    yield takeEvery(bulkCustomerCicReportingType.BULK_CUSTOMER_CIC_REPORTING_FILE_DOWNLOAD, downloadBulkCustomerCicReportingFile);
}

export function* watchFetchBulkFileSpecificCustomerCicReporting() {
    yield takeEvery(
        bulkCustomerCicReportingType.FETCH_BULK_FILE_SPECIFIC_CUSTOMER_CIC_REPORTING,
        fetchBulkFileSpecificCustomerCicReporting
    );
}

export function* watchApproveBulkCustomerCicReportingPublish() {
    yield takeEvery(bulkCustomerCicReportingType.APPROVE_BULK_CUSTOMER_CIC_REPORTING_FILE, approveBulkCustomerCicReportingFile);
}

export function* watchRejectBulkCustomerCicReportingPublish() {
    yield takeEvery(bulkCustomerCicReportingType.REJECT_BULK_CUSTOMER_CIC_REPORTING_FILE, rejectBulkCustomerCicReportingFile);
}


export function* watchDeleteBulkCustomerCicReportingFile() {
    yield takeEvery(bulkCustomerCicReportingType.DELETE_BULK_CUSTOMER_CIC_REPORTING_FILE, deleteBulkCustomerCicReportingFile);
}

function* BulkCustomerCicReportingSaga() {
    yield all([
        fork(watchUploadBulkCustomerCicReporting),
        fork(watchFetchBulkCustomerCicReporting),
        fork(watchFetchBulkCustomerCicReportingDetail),
        fork(watchBulkCustomerCicReportingVersion),
        fork(watchBulkCustomerCicReportingPublish),
        fork(watchDownloadBulkCustomerCicReporting),
        fork(watchFetchBulkFileSpecificCustomerCicReporting),
        fork(watchApproveBulkCustomerCicReportingPublish),
        fork(watchRejectBulkCustomerCicReportingPublish),
        fork(watchDeleteBulkCustomerCicReportingFile)
    ]);
}

export default BulkCustomerCicReportingSaga;
